"use client";

import {
  Container,
  Title,
  Text,
  Button,
  Stack,
  Box,
  Card,
  Group,
  SimpleGrid,
  List,
} from "@mantine/core";
import {
  IconPalette,
  IconPhoto,
} from "@tabler/icons-react";
import { Link } from "@/i18n/navigation";
import { useTranslations } from "next-intl";
import { trackCtaClick } from "@/lib/analytics";

export default function NeutralUndertonesWhatColorsSuitYouContent() {
  const t = useTranslations("neutralUndertones");

  return (
    <Container size="lg" py="xl">
      <Stack gap="xl">
        {/* Hero Section */}
        <Box ta="center">
          <Title order={1} size="h1" mb="md">
            {t("title")}
          </Title>
          <Text size="lg" c="dimmed" maw={600} mx="auto" mb="xl">
            {t("subtitle")}
          </Text>
        </Box>

        {/* Neutral Undertone Explanation */}
        <Card withBorder p="xl" radius="md">
          <Title order={2} mb="md">
            {t("sectionTitle")}
          </Title>
          <Text mb="lg">
            {t("intro")}
          </Text>
          <SimpleGrid cols={{ base: 1, md: 2 }} spacing="xl">
            <Box>
              <Title order={3} size="h4" mb="md" c="gray">
                {t("bestColorsTitle")}
              </Title>
              <List size="sm" spacing="xs">
                <List.Item>{t("bestColorsBalanced")}</List.Item>
                <List.Item>{t("bestColorsNeitherTooHot")}</List.Item>
                <List.Item>{t("bestColorsMuted")}</List.Item>
                <List.Item>{t("bestColorsVersatile")}</List.Item>
              </List>
            </Box>
            <Box>
              <Title order={3} size="h4" mb="md" c="violet">
                {t("seasonsTitle")}
              </Title>
              <List size="sm" spacing="xs">
                <List.Item>{t("seasonsSoftSummer")}</List.Item>
                <List.Item>{t("seasonsSoftAutumn")}</List.Item>
                <List.Item>{t("seasonsDeepWinter")}</List.Item>
                <List.Item>{t("seasonsBrightSpring")}</List.Item>
              </List>
            </Box>
          </SimpleGrid>
        </Card>

        {/* Bridge to virtual draping */}
        <Card withBorder p="xl" radius="md">
          <Title order={2} mb="md">
            See It On Your Own Face
          </Title>
          <Text mb="lg">
            Upload a selfie and our free virtual draping tool wraps you in gold vs silver, cream vs white, and
            warm vs cool red drapes — the same test analysts do in person. Free, no signup.
          </Text>
          <Button
            component={Link}
            href="/virtual-color-draping?src=bridge_neutral"
            color="violet"
            rightSection={<IconPalette size={20} />}
            onClick={() => trackCtaClick("bridge_neutral_vd")}
          >
            Drape Yourself Free
          </Button>
        </Card>

        {/* CTA */}
        <Box ta="center" py="xl">
          <Title order={2} mb="md">
            {t("ctaTitle")}
          </Title>
          <Text size="lg" c="dimmed" mb="xl">
            {t("ctaDescription")}
          </Text>
          <Group justify="center" gap="md">
            <Button
              size="xl"
              component={Link}
              href="/color-analysis-quiz"
              color="violet"
              rightSection={<IconPalette size={20} />}
            >
              {t("quizButton")}
            </Button>
            <Button
              size="xl"
              variant="outline"
              component={Link}
              href="/ai-color-analysis"
              color="violet"
              rightSection={<IconPhoto size={20} />}
            >
              {t("photoAnalysisButton")}
            </Button>
          </Group>
        </Box>
      </Stack>
    </Container>
  );
}
